import React from 'react';
import AddTransactionPageContent from '../components/addTransactionPageContent';


const AddTransaction = () =>{
    return(
        <AddTransactionPageContent/>
    );
}

export default AddTransaction;